module.exports = __webpack_public_path__ + "static/img/beta_bg_white_14.e3eb8582.svg";